import { render, staticRenderFns } from "./ProjectPowerCom.vue?vue&type=template&id=59c77119&"
import script from "./ProjectPowerCom.vue?vue&type=script&lang=ts&"
export * from "./ProjectPowerCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports